export function isFragmentHref(href: string): boolean {
  return href.startsWith('#');
}
